import { OnRedirectToNavigation, OnSearchButtonClick } from './navigation.type'

export const REDIRECT_TO_NAVIGATION = 'REDIRECT_TO_NAVIGATION'
export const SEARCH_BUTTON_CLICK = 'SEARCH_BUTTON_CLICK'

export const onRedirectToNavigation: OnRedirectToNavigation = () => ({
  type: REDIRECT_TO_NAVIGATION
})

export const onSearchButtonClick: OnSearchButtonClick = () => ({
  type: SEARCH_BUTTON_CLICK
})
